module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("My debt to the historians listed in the bibliography is evident. I hope that this introduction to the guerrilla war in Missouri will make the reader want to learn more about the subjects these authors have explored in depth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I want to acknowledge the assistance of Sara Przybylski at the State Historical Society of Missouri at Columbia, Missouri, and Dorris Keeven-Franke at the St. Charles Historical Society for their help in obtaining photographs and illustrations for this book. I also want to thank Colter Sikora for the excellent maps.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, I must give the most credit to my wife, Vicki. Without her encouragement, suggestions and, yes, prodding, this book would never have been conceived, let alone completed. Thanks, Vicki, I love you.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bee5018e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/acknowledgements.vue
// module id = 69
// module chunks = 0